import { Controller } from "@hotwired/stimulus"

// Show/hide toggle for a password field (the sign-in form's eye button).
//
// This used to be an inline <script> in devise/sessions/new. Inline scripts only run on a full page
// load here: the CSP nonce is new on every response, and on a Turbo navigation Turbo stamps the new
// page's nonce onto the scripts it runs, which the document's original policy refuses. Reaching the
// sign-in page from a link left the button dead (GAS2DOOR-47). A Stimulus controller ships in the
// application pack, which script-src 'self' allows however the page was reached.
export default class extends Controller {
  static targets = ["input", "icon", "button"]

  toggle() {
    const showing = this.inputTarget.type === 'text'
    this.inputTarget.type = showing ? 'password' : 'text'
    this.iconTarget.className = showing ? 'fas fa-eye' : 'fas fa-eye-slash'
    this.buttonTarget.setAttribute('aria-label', showing ? 'Show password' : 'Hide password')
  }
}
